import * as yup from 'yup';
import { translate } from '../../../shared/i18n';

export const schemaProduct = yup.object().shape({
  name: yup
    .string()
    .required(translate('productModal.validation.nameRequired')),
  product_type: yup
    .number()
    .required(translate('productModal.validation.productTypeRequired')),
  sale_price: yup.number().when('product_type', {
    is: 1,
    then: (schema) =>
      schema
        .min(0.01, translate('productModal.validation.salePriceMin'))
        .required(translate('productModal.validation.salePriceRequired')),
    otherwise: (schema) =>
      schema
        .min(0, translate('productModal.validation.salePriceInvalid'))
        .default(0),
  }),
  minimum_inventory: yup
    .number()
    .min(1, translate('productModal.validation.minimumInventoryMin'))
    .required(translate('productModal.validation.minimumInventoryRequired')),
  maximum_inventory: yup
    .number()
    .min(1, translate('productModal.validation.maximumInventoryMin'))
    .required(translate('productModal.validation.maximumInventoryRequired')),
});
